import {FiMapPin as LocationIcon, FiTag as TagIcon} from 'react-icons/fi';
import {
  PiFactory as IndustryIcon,
  PiTextT as CompanyNameIcon,
  PiUsersThree as SizeIcon,
} from 'react-icons/pi';
import {TbTransfer as CRMIcon} from 'react-icons/tb';
import {FilterKind, FiltersConfig} from '../../components/filters';
import {CompanyNameListIcon, WebsitesListIcon} from '../../components/icons';
import {extractDomain, isValidDomain} from '../../utils/urlCheckers';

export const filtersConfig: FiltersConfig = {
  filtersName: 'companiesFilters',
  categories: [
    {
      key: 'companiesFilters',
      title: 'Companies Filters',
    },
    {
      key: 'generalData',
      title: 'General Data',
    },
    {
      key: 'integrationsFilters',
      title: 'Integrations Filters',
    },
  ],
  filters: {
    name: {
      key: 'name',
      title: 'Company Name',
      icon: () => <CompanyNameIcon />,
      category: 'companiesFilters',
      kind: FilterKind.ENUM,
    },
    nameList: {
      key: 'nameList',
      title: 'List of Companies',
      icon: () => <CompanyNameListIcon />,
      category: 'companiesFilters',
      kind: FilterKind.LIST,
      modalTitle: 'List of Companies',
      modalDescription: 'Enter company names below (separated by commas or line breaks)',
      tokensLabel: 'Recognized company names',
    },
    website: {
      key: 'website',
      title: 'Websites',
      icon: () => <WebsitesListIcon />,
      category: 'companiesFilters',
      kind: FilterKind.LIST,
      modalTitle: 'Websites',
      modalDescription: 'Paste a list of company websites (separated by commas or line breaks)',
      tokensLabel: 'Recognized websites',
      transformRule: extractDomain,
      matchingRule: isValidDomain,
      placeholderText:
        'for example:\n' +
        'https://theswarm.com\n' +
        'https://www.google.com\n' +
        'https://apple.com/\n' +
        'www.amazon.com\n' +
        '...\n',
      matchingLinesInfo: {
        title: 'Domain matching tester',
        message: 'Please enter valid websites, one per line.',
        successMessage: 'All domains are valid.',
        failMessage: 'Some domains are invalid. Please correct them.',
      },
    },
    size: {
      key: 'size',
      title: 'Company Size',
      icon: () => <SizeIcon />,
      category: 'companiesFilters',
      kind: FilterKind.ENUM,
    },
    industry: {
      key: 'industry',
      title: 'Company Industry',
      icon: () => <IndustryIcon />,
      category: 'companiesFilters',
      kind: FilterKind.ENUM,
    },
    location: {
      key: 'location',
      title: 'Company Headquaters',
      icon: () => <LocationIcon />,
      category: 'companiesFilters',
      kind: FilterKind.ENUM,
    },
    tag: {
      key: 'tag',
      title: 'Company Tags',
      icon: () => <TagIcon />,
      category: 'companiesFilters',
      kind: FilterKind.ENUM,
      decorator: 'tag',
    },
    // crm filter is currently not used anywhere
    crm: {
      key: 'crm',
      title: 'CRM Source',
      icon: () => <CRMIcon />,
      category: 'integrationsFilters',
      kind: FilterKind.ENUM,
      decorator: 'crm',
      searchable: false,
    },
  },
  availableFilters: ['name', 'nameList', 'website', 'industry', 'size', 'location', 'tag'],
};
